<template>
<div class="index-notice container-md">
  <div class="notice-box">
    <div class="content">
      <template v-if="noticeList && noticeList.length">
        <div class="label"></div>
        <div class="notice-list-box">
          <div class="notice-list"  :style="{top: -noticeTop + 'px',}">
            <div @click="showMessage($event, item)" class="notice-item" v-for="(item, index) in noticeList" :key="index">【{{item.title}}】{{item.content}}</div>
            <!-- 这个渲染的是为了动画 -->
            <template v-if="noticeList && noticeList.length > 2">
              <div @click="showMessage($event, item)" class="notice-item" v-for="(item, index) in noticeList" :key="index + 'animation'">【{{item.title}}】{{item.content}}</div>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="notice-list-null">
          暂无最新公告通知
        </div>
      </template>
      <router-link :to="{ name: 'message', query: { type: 2 } }" class="all-notice">
        查看更多公告
        <img class="icon" src="https://o.666visa.cn/static/ssqpeer/homepage/icon-right-white.png" alt="">
      </router-link>
    </div>

  </div>
  <div class="jump-box appointment-box" @click="goEarlistDate">
    <div class="content">
      <p>最近可预约</p>
      <p>日期</p>
    </div>
  </div>
  <div class="jump-box holiday-box" @click="goEmbassyHoliday">
    <div class="content">
      <p>使馆假期</p>
      <p>近两月</p>
    </div>
  </div>
  <div class="jump-box on-job-box" @click="goOnJob">
    <div class="content">
      <p>在职证明</p>
      <p>快速生成</p>
    </div>
  </div>
  <!-- <div class="jump-box insurance-box" @click="goTravelInsurance">
    <div class="content">
      <p>保险</p>
      <p>商城</p>
    </div>
  </div> -->
</div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import Http from '../../../libs/http';

export default {
  name: 'index-notice',
  props: {
    noticeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      noticeIndex: 0,
      noticeTop: 0,
    };
  },
  created() {
    this.initNoticeAnimation();
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    showMessage(e, item) {
      sensorsdata.quick('trackHeatMap', e.target);
      NoticeModal.modal({
        title: item.title,
        message: item.content,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
      });
      Http.post('/sys/notice_click', { id: item.id });
    },
    initNoticeAnimation() {
      if (this.noticeList.length > 2) {
        this.timer = setInterval(() => {
          this.gotoNextNotice();
        }, 3000);
      }
    },
    gotoNextNotice() {
      const time = 500;
      const step = 20;
      const noticeHeight = 28;
      let nowStep = 0;
      const singleStepHeight = noticeHeight / step;
      const timer = setInterval(() => {
        nowStep += 1;
        this.noticeTop = this.noticeIndex * noticeHeight + (singleStepHeight * nowStep);
        if (nowStep >= step) {
          this.noticeIndex += 1;
          if (this.noticeIndex >= this.noticeList.length) {
            this.noticeIndex = 0;
            this.noticeTop = 0;
          }
          clearInterval(timer);
        }
      }, time / step);
    },
    // 到最早可预约时间界面
    goEarlistDate(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      sensorsdata.track('Appointment_time', {});
      this.$emit('switchEarlistDatePop');
    },

    // 到使馆假期界面
    goEmbassyHoliday(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      sensorsdata.track('Embassy_holidays', {});
      this.$emit('switchAllEmbassyHolidayPop');
      // this.$router.push({ name: 'embassyHoliday' });
    },

    // 到旅游保险界面
    goTravelInsurance(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.$router.push({ name: 'insurances', query: { from: 'index_section_insurance' } });
    },

    // 在职证明
    goOnJob(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      sensorsdata.track('Index_jobcertificate', {});
      this.$router.push({ name: 'OnJobList' });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/variable";
.index-notice{
  height: 80px;
  display: flex;
  margin-top: 16px;
  margin-bottom: 48px;
  .notice-box{
    flex-grow: 1;
    background: linear-gradient(270deg,rgba(113,167,244,1) 0%,rgba(70,132,221,1) 100%);
    border-radius:4px;
    position: relative;
    &::after{
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 80px;
      background: url('https://o.666visa.cn/static/ssqpeer/homepage/icon-notice.png') no-repeat right;
      background-size: 100% 100%;
    }
    .content{
      padding: 16px;
      display: flex;
      position: relative;
      z-index: 2;
      .notice-list-null{
        color: rgba(255, 255, 255, 0.6);
        font-size: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
      }
      .label{
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        background: url(https://o.666visa.cn/static/ssqpeer/homepage/new-notice.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
      }
      .notice-list-box{
        flex-grow: 1;
        margin-right: 28px;
        height: 48px;
        overflow: hidden;
        position: relative;
        .notice-list{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          .notice-item{
            cursor: pointer;
            font-size: 14px;
            color: #fff;
            line-height: 20px;
            margin-bottom: 8px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &:hover{
              text-decoration: underline;
            }
          }
        }
      }

      .all-notice{
        flex-shrink: 0;
        font-size: 14px;
        color: #fff;
        line-height: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 20px;
        .icon{
          width: 10px;
          height: 10px;
        }
      }
    }
  }
  .jump-box {
    width: 152px;
    margin-left: 16px;
    border-radius:4px;
    position: relative;
    z-index: 1;
    cursor: pointer;
    .content{
      position: relative;
      z-index: 2;
      padding: 16px;
      p {
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        line-height: 1;
        padding-bottom: 6px;
      }
      .title{
        color: #fff;
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 4px;
      }
      .sub-title{
        font-size: 20px;
        line-height: 22px;
        color: rgba(255, 255, 255, 0.3)
      }
    }
    &::after{
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 80px;
      background: url('https://o.666visa.cn/static/ssqpeer/homepage/icon-appointment.png') no-repeat right;
      background-size: 100% 100%;
    }
    &:hover{
      &::before{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background:rgba(255,255,255,1);
        opacity:0.15;
        border-radius:4px;
        z-index: 2;
      }
    }
  }
  .appointment-box{
    background:linear-gradient(270deg,rgba(249,134,124,1) 0%,rgba(255,117,105,1) 100%);
    &::after{
      background: url('http://o.666visa.cn/static/ssqpeer/homepage/icon-appointment.png') no-repeat right;
      background-size: 100% 100%;
    }
  }
  .holiday-box{
    background:linear-gradient(270deg,rgba(55,204,227,1) 0%,rgba(8,192,218,1) 100%);
    &::after{
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 80px;
      height: 80px;
      background: url('https://o.666visa.cn/static/ssqpeer/homepage/icon-holiday.png') no-repeat right;
      background-size: 100% 100%;
    }
  }
  .insurance-box {
    background:linear-gradient(270deg,rgba(150,135,224,1) 0%,rgba(140,123,223,1) 100%);
    &::after{
      background: url('../../../assets/imgs/order/icon-保险@2x.png') no-repeat right;
      background-size: 100% 100%;
    }
  }
  .on-job-box {
    background: linear-gradient(270deg, #53C3FF 0%, #35B0F2 100%);
    &::after{
      background: url('../../../assets/imgs/homepage/on-job-bg.png') no-repeat right;
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-notice.vue